"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compress = compress;
exports.default = void 0;

var _zip = _interopRequireDefault(require("../$zip/zip"));

var _filter = require("../$filter/filter");

var _map = require("../$map/map");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function compress(source, included) {
  return (0, _map.map)((0, _filter.filter)((0, _zip.default)(source, included), entry => entry[1]), entry => entry[0]);
}

var _default = compress;
exports.default = _default;